export default "<!-- <app-spinner></app-spinner> -->\n<router-outlet></router-outlet>"